import { Component, OnInit } from '@angular/core';
import {LoaderService} from '../../../services/loader.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ReceiptService} from '../../../services/receipt.service';
import {ModalReceiptDetailsComponent} from '../modal-receipt-details/modal-receipt-details.component';

@Component({
  selector: 'modal-receipts-list',
  templateUrl: './modal-receipts-list.component.html',
  providers: [LoaderService]
})
export class ModalReceiptsListComponent implements OnInit {


  items: any = [];
  id: string;

  constructor(public modalRef: BsModalRef,
              public loaderService: LoaderService,
              private modelService: ReceiptService,
              private modalService: BsModalService) { }

  ngOnInit(): void {
  }


  showReceipt(id: any) {
    this.modalService.show(ModalReceiptDetailsComponent, {
      initialState: {id},
    });
  }

}
